import { render } from "./QuanLyDonHangKho.vue?vue&type=template&id=150cfabd&scoped=true"
import script from "./QuanLyDonHangKho.vue?vue&type=script&lang=js"
export * from "./QuanLyDonHangKho.vue?vue&type=script&lang=js"

import "./QuanLyDonHangKho.vue?vue&type=style&index=0&id=150cfabd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150cfabd"]])

export default __exports__